var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3h1v2h-1v2a1 1 0 01-2 0V5H3v2a1 1 0 01-2 0V5H0V3h1V1a1 1 0 012 0v2h18V1a1 1 0 012 0v2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.415 5.713L15.307 14H8.693L5.585 5.713l-1.873.7L7 15.18V23h10v-7.82l3.288-8.765-1.873-.702z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a3 3 0 100-6 3 3 0 000 6z"
  })));
}
export default SvgTrainingFill;